/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit MinDueAmount/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function MinDueAmount({
  children,
  viewPath = "/App/Account/Content/Financial/Content/Statements/MinDueAmount",
  onChange
  
}) {
let tabSelectedStatementsMinDueNowAmountValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.statements.min_due_now_amount',
})
let tabSelectedStatementsMinDueNowAmountChangeData = fromData.useDataChange({ viewPath,
context: 'tab',
path: 'selected.statements.min_due_now_amount',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 flexGrow={0}
 type="number"
 marginTop={dtSpaceS}
 data="tab.selected.statements.min_due_now_amount"
 onChange={tabSelectedStatementsMinDueNowAmountChangeData}
 value={tabSelectedStatementsMinDueNowAmountValueData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Min due amount ($)"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}